<template>
  <div class="consult-card">
    <div class="tags">
      <div class="tag on" v-if="content.status === 1"><span>已发布</span></div>
      <div class="tag off" v-if="content.status === 0"><span>未发布</span></div>
    </div>
    <div class="content-wrap">
      <div class="left">
        <img :src="content.picture_url">
      </div>
      <div class="right">
        <p class="title">{{content.name}}</p>
        <p class="subtitle">{{content.description}}</p>
        <p class="category">{{content.category.name || ''}}</p>
      </div>
    </div>
    <div class="menu">
      <div class="menu-item">
        <router-link :to="`/consult/${content.id}`">
          <i class="el-icon-edit"></i>
          <span>编辑</span>
        </router-link>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handleToPreview">
        <i class="el-icon-zoom-in"></i>
        <span>浏览</span>
      </div>
      <div class="divider"></div>
      <div class="menu-item" @click="handelConsultRemove">
        <i class="el-icon-delete"></i>
        <span>删除</span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'exercise-card',
    props: {
      content: {
        type: Object,
        default: () => {return {}}
      }
    },
    data() {
      return {}
    },
    methods: {
      handelConsultRemove() {
        this.$emit('remove', this.content.id)
      },
      // 预览
      handleToPreview() {

      }
    }
  }
</script>

<style lang="less" scoped>
.consult-card {
  position: relative;
  width: 260px;
  color: #303133;
  background-color: #FFF;
  border: 1px solid #EBEEF5;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  border-radius: 4px;
  padding: 30px 10px 0px;
  overflow: hidden;

  .tags {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;

    .tag {
      background: #ff6600;
      border-radius: 4px;
      border-top-right-radius: 0px;
      border-bottom-left-radius: 0px;
      font-size: 12px;
      color: #fff;
      padding: 3px 10px;

      &:not(:first-child) {
        margin-left: 5px;
      }
      &.on {
        background: #409EFF;
      }
    }
  }

  .content-wrap {
    display: flex;

    .left {
      margin-right: 10px;
    }
    .right {
      display: flex;
      flex-direction: column;
      flex: 1;
      overflow: hidden;
    }
    img {
      width: 69px;
      height: 94px;
      object-fit: cover;
    }
    .title {
      font-size: 14px;
      font-weight: bold;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap; //溢出不换行
    }
    .subtitle {
      flex: 1;
      font-size: 13px;
      margin-top: 10px;
    }
    .category {
      font-size: 14px;
      margin-top: 20px;
    }
  }
  .item-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #666;
    margin-top: 10px;

    .subject-name {
      flex: 1;
      overflow:hidden; //超出的文本隐藏
      text-overflow:ellipsis; //溢出用省略号显示
      white-space:nowrap; //溢出不换行
    }
    .member-count {
      margin-left: 10px;
    }
  }
  a {
    text-decoration: none;
  }
  .menu {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f2f2f2;
    margin: 10px -10px 0;

    .menu-item {
      display: flex;
      justify-content: center;
      cursor: pointer;
      padding: 10px 20px;

      i {
        margin-right: 2px;
      }
    }
    .divider {
      height: 20px;
      border-right: 1px solid #ccc;
    }
  }
}
</style>
